export const credentialsQueryKeys = {
  all: ["credentials"] as const,
  list: ({
    sport,
    organizationId,
  }: {
    sport: string | undefined;
    organizationId: string | undefined;
  }) => [...credentialsQueryKeys.all, "list", sport, organizationId] as const,
};
